/** Storyblok number fields arrive as strings; empty means "not set". */
type NumberField = string | number | null | undefined;

const toPx = (value: NumberField): string | undefined => {
	const px = Number(value);
	return Number.isFinite(px) && px > 0 ? `${px}px` : undefined;
};

/**
 * The CategoryHero's own height caps as CSS variables, for the template's CSS
 * to read (`--category-hero-max` from lg, `--category-hero-max-mobile` below
 * it). Unset fields are left out, so the template default applies; undefined
 * when neither is set.
 */
export const categoryHeroMaxHeight = (
	desktop: NumberField,
	mobile: NumberField
): Record<string, string> | undefined => {
	const vars = Object.fromEntries(
		[
			["--category-hero-max", toPx(desktop)],
			["--category-hero-max-mobile", toPx(mobile)]
		].filter((entry): entry is [string, string] => !!entry[1])
	);
	return Object.keys(vars).length ? vars : undefined;
};
